import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID,NgModule  } from '@angular/core';
import { GoogleMapsModule } from "@angular/google-maps";

import { RouterModule} from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

// Rutas
import {  ROUTES } from './app.routes';

// Servicios
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
registerLocaleData(localeEsAr, 'es-Ar');
// Componentes
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { LoginComponent } from './components/admin/login/login.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { FilterComponent } from './components/shared/filter/filter.component';
import { HomeComponent } from './components/home/home.component';
import { PropertiesComponent } from './components/properties/properties.component';
import { ContactComponent } from './components/contact/contact.component';
import { PropertieDetailsComponent } from './components/propertie-details/propertie-details.component';
import { NoimagePipe } from './pipes/noimage.pipe';
import { IconsPipe } from './pipes/icons.pipe';
import { LoadingComponent } from './components/shared/loading/loading.component';
import { AlertComponent } from './components/shared/alert/alert.component';
import { PrincipalComponent } from './components/admin/principal/principal.component';
import { AuthInterceptorService } from './interceptors/auth-interceptor.service';
import { AdminComponent } from './components/admin/admin/admin.component';
import { LogoutComponent } from './components/admin/logout/logout.component';
import { CardComponent } from './components/shared/card/card.component';
import { UploadComponent } from './components/shared/LoadFiles/upload/upload.component';
import { CardImageComponent } from './components/shared/LoadFiles/card-image/card-image.component';
import { ColorEstado } from './pipes/colorestado.pipe';
import { AddPropertieComponent } from './components/admin/properties/add-propertie/add-propertie.component';
import { UpdatePropertieComponent } from './components/admin/properties/update-propertie/update-propertie.component';
import { MapComponent } from './components/map/map.component';
import { DomseguroPipe } from './pipes/domseguro.pipe';
import { MapPickerComponent } from "./components/admin/map-picker/map-picker.component";
import { map } from 'rxjs';

// import { MapComponent } from './components/map/map.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    CarouselComponent,
    NavbarComponent,
    FilterComponent,
    HomeComponent,
    PropertiesComponent,
    ContactComponent,
    PropertieDetailsComponent,
    NoimagePipe,
    IconsPipe,
    ColorEstado,
    DomseguroPipe,
    LoadingComponent,
    AlertComponent,
    PrincipalComponent,
    AdminComponent,
    LogoutComponent,
    CardComponent,
    UploadComponent,
    CardImageComponent,
    AddPropertieComponent,
    UpdatePropertieComponent,
    MapComponent,
    // MapPickerComponent
    // MapComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(ROUTES, {
                                  useHash: false,
                                  onSameUrlNavigation: 'reload'
                                }),

    GoogleMapsModule
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyB28QUbblJRVDtRY3qhh55WC3Z_ocye9ZY'
    // })
    ,
    MapPickerComponent
],
  providers: [
    {
    provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es-Ar' } 
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA] 
})
export class AppModule { }
